import Vue from 'vue'
import Router from 'vue-router'
import IndexNew from '@/components/IndexNew'
import PaymentIndex from '@/components/PaymentIndex'
import PaymentCheckout from '@/components/PaymentCheckout'
import PaypalResultDone from '@/components/PaypalResultDone'
import PaypalResultErr from '@/components/PaypalResultErr'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'development' ? '' : '/3d/prova-modello/',
  routes: [
    {
      path: '',
      name: 'e3d',
      component: IndexNew
    },
    {
      path: '/payment',
      name: 'Payment',
      component: PaymentIndex,
      children: [
        {
          path: '/checkout',
          name: 'PaymentCheckout',
          component: PaymentCheckout
        },
        {
          path: '/done/:id_cart',
          name: 'PaypalResultDone',
          component: PaypalResultDone
        },
        {
          path: '/error/:id_cart',
          name: 'PaypalResultErr',
          component: PaypalResultErr
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js